import _                           from 'underscore';
import React, { FC, useContext }   from 'react';
import { useQuery }                from '@apollo/react-hooks';
import { QueriedSelectFieldProps } from '../formik';

import { queriesHaveData, queriesLoading } from '../../../../store/_apolloUtil';
import { CorvalSubObjective }              from '../../../../types';
import { DecisionEngineQueries }           from '../../../../queries';
import { formatOption }                    from '../../../../util';
import { SelectField }                     from '../../../components/forms';
import { ProjectContext }                  from "@src/views/pages/projects/ProjectIndexPage";


interface ObjectiveDropdownProps extends QueriedSelectFieldProps {
    loading?: boolean,
    formatOptions?: object,
}

const defaultProps: ObjectiveDropdownProps = {
    loading:       false,
    formatOptions: {}
};

const QueryDropdown: FC<ObjectiveDropdownProps> = ( _props ) => {

    let { formatOptions, ...props } = _props,
        projectContext              = useContext( ProjectContext );

    let getObjectivesReq = useQuery(
        DecisionEngineQueries.queries.GET_SUBOBJECTIVES( `id name objective { name }` ), {
            fetchPolicy: 'cache-and-network',
            variables:   {
                projectId: projectContext?.projectId ?? null
            }
        }
    );

    let isLoading = ( props.loading || queriesLoading( getObjectivesReq ) );

    let options = ( queriesHaveData( getObjectivesReq ) )
                  ? _.sortBy( getObjectivesReq.data.subObjectives, 'name' )
                     .map( ( subObjective: CorvalSubObjective ) => {

                         let { id, name, objective } = subObjective;

                         return formatOption( id, name, { group: objective.name, ...formatOptions } );
                     } )
                  : [];

    return (
        <SelectField
            { ...props }
            loading={ isLoading }
            options={ options }>
        </SelectField>
    );
};

QueryDropdown.defaultProps = defaultProps;

export { QueryDropdown as ObjectiveDropdown };
